import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { analytics_url } from '../../environments/environment';
import { Observable } from 'rxjs';

export const EventType = {
  SiteVisitNew: 'siteVisitNew',
  SiteVisitPing: 'siteVisitPing',
  SiteVisitExit: 'siteVisitExit',

  PageViewNew: 'pageViewNew',
  PageViewStart: 'pageViewStart',
  PageViewFinish: 'pageViewFinish',
  PageViewPing: 'pageViewPing',
  PageViewExit: 'pageViewExit',

  SectionViewNew: 'sectionViewNew',
  SectionViewStart: 'sectionViewStart',
  SectionViewFinish: 'sectionViewFinish',
  SectionViewPing: 'sectionViewPing',
  SectionViewExit: 'sectionViewExit',

  LiveEventViewNew: 'liveEventViewNew',
  LiveEventViewStart: 'liveEventViewStart',
  LiveEventViewFinish: 'liveEventViewFinish',
  LiveEventViewPing: 'liveEventViewPing',
  LiveEventViewExit: 'liveEventViewExit',
} as const;

export interface AnalyticsEvent<TProps extends object> {
  eventType: EventType;
  properties: TProps;
}

export type EventType = typeof EventType[keyof typeof EventType];

@Injectable()
export class StatisticsService {

  private httpOptions = {
    headers: new HttpHeaders({
      'Authorization': '',
    })
  };


  createSecurityHeaders() {
    const cookie = document.cookie.match(new RegExp('(^| )' + 'cuentame_token' + '=([^;]+)'));
    // const token = localStorage.getItem('id_token');
    // console.log(token)
    const token = cookie ? cookie[2] : null;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token!,
      })
    };
    return this.httpOptions;
  }
  
  public siteVisitUuid!: string | null;
  public timestamp!: string | null;

  constructor(public http: HttpClient) { }

  sendAnalyticsEvent<T extends object>(event: AnalyticsEvent<T>): Observable<any> {
    return this.http.post(analytics_url+'/event', event, this.createSecurityHeaders());
  }
}


